import React from 'react'

interface RichTextViewProps {
  html: string | null | undefined
  className?: string
  fallback?: React.ReactNode
}

/**
 * Returns true when a rich-text value has no visible content. Treats Quill's
 * empty placeholders (`<p><br></p>` / `<p></p>`) as empty so we can show a
 * fallback in lists and badges.
 */
export function isRichTextEmpty(html: string | null | undefined): boolean {
  const normalized = (html ?? '').trim()
  return (
    normalized === '' ||
    normalized === '<p><br></p>' ||
    normalized === '<p></p>'
  )
}

/**
 * Render rich text HTML produced by {@link RichTextEditor}. The Quill toolbar
 * is constrained to bold/italic/lists so the markup is limited to a small
 * whitelist of formatting tags, but we still avoid raw rendering elsewhere by
 * funneling all reads through this component.
 */
export function RichTextView({
  html,
  className,
  fallback = null,
}: RichTextViewProps) {
  if (isRichTextEmpty(html)) {
    return <>{fallback}</>
  }

  return (
    <div
      className={`gw-rich-text-view${className ? ` ${className}` : ''}`}
      dangerouslySetInnerHTML={{ __html: (html ?? '').trim() }}
    />
  )
}

export default RichTextView
